import { HttpResponse, http } from 'msw';

import { environment } from '../../environments/environment';

const env = { ...environment };
const module = env.services.users;
const envServiceUrl = module.url;

const STORE_NAMES = [
  'PITI-รวมโชค',
  'PITI-ท่ารั้ว',
  'PITI-ดอนตะโก',
  'PITI-บ้านโป่ง',
  'PITI-หนองปลาไหล',
  'PITI-เขาย้อย'
];

const buildStores = (total: number) =>
  Array.from({ length: total }, (_, index) => {
    const areaManager = `AM0${(index % 4) + 1}`;
    const regionalManager = `RM0${(index % 3) + 1}`;

    return {
      code: `PITI${String(index + 1).padStart(4, '0')}`,
      no: String(index + 151).padStart(6, '0'),
      name: `${STORE_NAMES[index % STORE_NAMES.length]} ${index + 1}`,
      regionalStructures: [areaManager, regionalManager, index % 2 === 0 ? 'RO01' : 'RO02']
    };
  });

const stores = buildStores(60);

const countStores = (code: string) => stores.filter(store => store.regionalStructures.includes(code)).length;

const buildStructures = (prefix: string, total: number, name: string) =>
  Array.from({ length: total }, (_, index) => {
    const code = `${prefix}0${index + 1}`;

    return { code, name: `${name} #${index + 1}`, totalStore: countStores(code) };
  });

/**
 * Failure modes for local testing, switched from DevTools without a rebuild:
 *   localStorage.setItem('msw.authorityScopes', '500')      // master list (Create/Edit)
 *   localStorage.setItem('msw.userAuthorityScopes', '404')  // user scopes (View)
 * Values: 'empty' | '404' | '500' | 'network'. Remove the key to get the normal response.
 */
const failureResponse = (key: string) => {
  const mode = localStorage.getItem(key);

  if (mode === 'network') {
    return HttpResponse.error();
  }
  if (mode === '404' || mode === '500') {
    return HttpResponse.json({ code: mode, message: `Mocked ${mode} from ${key}` }, { status: Number(mode) });
  }
  if (mode === 'empty') {
    return HttpResponse.json({ regionalStructures: [], stores: [] });
  }

  return null;
};

const getAuthorityScopesResolver = () =>
  failureResponse('msw.authorityScopes') ||
  HttpResponse.json({
    regionalStructures: [
      { level: 'REGIONAL_OFFICE', structures: buildStructures('RO', 2, 'Regional Office') },
      { level: 'REGIONAL_MANAGER', structures: buildStructures('RM', 3, 'Regional Manager') },
      { level: 'AREA_MANAGER', structures: buildStructures('AM', 4, 'Area Manager') }
    ],
    stores
  });

const getUserAuthorityScopesResolver = () => {
  const areaManagers = ['AM01', 'AM02'];

  return (
    failureResponse('msw.userAuthorityScopes') ||
    HttpResponse.json({
      regionalStructures: [
        {
          level: 'AREA_MANAGER',
          structures: areaManagers.map(code => ({
            code,
            name: `Area Manager #${code.slice(-1)}`,
            totalStore: countStores(code)
          }))
        }
      ],
      stores: stores.filter(store => store.regionalStructures.some(code => areaManagers.includes(code)))
    })
  );
};

export const handlers = [
  http.get(env.serverUrl + envServiceUrl + module.authorityScopes, getAuthorityScopesResolver),
  http.get(
    env.serverUrl + envServiceUrl + module.userAuthorityScopes.replace('{no}', ':no'),
    getUserAuthorityScopesResolver
  )
];
